import { Droplets } from "lucide-react";

const ITEMS = [
    "Fresh & Clean",
    "Laundry Kiloan",
    "Satuan Premium",
    "Gratis Antar Jemput",
    "Proses Higienis",
    "Express 6 Jam",
];

function Ribbon() {
    return (
        <div className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="whitespace-nowrap px-8 font-display text-sm font-bold uppercase tracking-[0.3em] text-brand/80">
                        {item}
                    </span>
                    <Droplets size={14} className="shrink-0 text-brand" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <section
            data-testid="marquee-ribbon"
            className="marquee overflow-hidden border-y border-brand/10 bg-brand-mist/60 py-5"
            aria-hidden="true"
        >
            <div className="marquee-track">
                <Ribbon />
                <Ribbon />
            </div>
        </section>
    );
}
